

export const HORSE_RACE_UPDATE_RECEIVED = "HORSE_RACE_UPDATE";
export const HORSE_RACE_UPDATE_RECEIVE_ERROR = "HORSE_RACE_UPDATE_RECEIVE_ERROR";
export const HORSE_RACE_UPDATE_SUBSCRIBE = "HORSE_RACE_UPDATE_SUBSCRIBE";
export const HORSE_RACE_UPDATE_SUBSCRIBE_ERROR = "HORSE_RACE_UPDATE_SUBSCRIBE_ERROR";
export const HORSE_RACE_UPDATE_SUBSCRIBED = "HORSE_RACE_UPDATE_SUBSCRIBED";
export const HORSE_RACE_UPDATE_CONNECT = "HORSE_RACE_UPDATE_CONNECT";
export const HORSE_RACE_UPDATE_CONNECT_ERROR = "HORSE_RACE_UPDATE_CONNECT_ERROR";
export const HORSE_RACE_UPDATE_UNSUBSCRIBE = "HORSE_RACE_UPDATE_UNSUBSCRIBE";
export const HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR = "HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR";
export const HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS = "HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS";
export const HORSE_RACE_UPDATE_FALLBACK_TO_POLLING = "HORSE_RACE_UPDATE_FALLBACK_TO_POLLING";
export const HORSE_RACE_UPDATE_DISCONNECTED = "HORSE_RACE_UPDATE_DISCONNECTED";
export const HORSE_RACE_UPDATE_DISCONNECTING = "HORSE_RACE_UPDATE_DISCONNECTING";


export const connectToRaceUpdates = (countryGroups = []) => {
    return {countryGroups, type: HORSE_RACE_UPDATE_CONNECT}
}

export const unSubscribeRaceUpdates = () => {
    return {type: HORSE_RACE_UPDATE_DISCONNECTING};
}

export const subscribeToRaceUpdates = (countryGroups = [], unsubscribe = true) => {
    return {countryGroups, unsubscribe, type: HORSE_RACE_UPDATE_SUBSCRIBE}
}


// WEBPACK FOOTER //
// ./modules/HorseRacing/actions/raceUpdate.js